import { render, staticRenderFns } from "./Scatter.vue?vue&type=template&id=751ae637&scoped=true&"
import script from "./Scatter.vue?vue&type=script&lang=js&"
export * from "./Scatter.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "751ae637",
  null
  
)

export default component.exports